import { decodeAndStripHtml } from '@dupe/common/research-report'
import { renderRichText } from './richText'
import type { HubFaqSection, HubSectionComponentProps } from './types'

export function HubFaq({ section }: HubSectionComponentProps<HubFaqSection>) {
  if (section.items.length === 0) return null

  return (
    <section id={section.id} className='flex flex-col gap-5'>
      {section.title && (
        <h2 className='font-display text-2xl font-bold leading-8 text-foreground'>
          {section.title}
        </h2>
      )}
      {section.dek && (
        <p className='text-base leading-6 text-foreground-secondary'>
          {section.dek}
        </p>
      )}

      <div className='flex flex-col gap-3'>
        {section.items.map((item, index) => (
          <details
            key={`${item.question}-${item.answer.slice(0, 24)}`}
            open={index === 0}
            className='group rounded-2xl border-[0.5px] border-border bg-ds-bg-secondary p-4'
          >
            <summary className='cursor-pointer list-none text-balance font-display text-base font-semibold leading-6 text-foreground marker:hidden [&::-webkit-details-marker]:hidden'>
              <span>{decodeAndStripHtml(item.question)}</span>
            </summary>
            <p className='mt-2 text-pretty text-sm leading-6 text-ds-text-quaternary'>
              {renderRichText(item.answer)}
            </p>
          </details>
        ))}
      </div>
    </section>
  )
}
